import {
  EventBus
} from '@/event-bus';

export default {
  currentlyLoading: false,
  loadingPromises: [],
  finalData: [],
  watchPromises(promises) {

    let newLoadingPromise = this.createPromise(promises).then((data) => {
      this.loadingPromises.shift();
      setTimeout(() => {
        if (this.loadingPromises.length === 0) {
          this.resetLoadingService();
        }
      }, 0);
      return data;
    }).catch(e => {
      this.loadingPromises.shift();
      setTimeout(() => {
        if (this.loadingPromises.length === 0) {
          this.resetLoadingService();
        }
      }, 0);
      throw e;
    });

    this.loadingPromises.push(newLoadingPromise);
    return this.loadingPromises[this.loadingPromises.length - 1];
  },
  formatPromises(promises) {
    return Array.isArray(promises) ? promises : [promises];
  },
  createPromise(promises) {
    this.currentlyLoadingOn();
    this.emitStartEvent();

    return Promise.all(this.formatPromises(promises)).catch(e => {
      throw e;
    });
  },
  resetLoadingService() {
    this.currentlyLoadingOff();
    this.resetLoadingPromise();
    this.emitFinishEvent();
  },
  currentlyLoadingOn() {
    this.currentlyLoading = true;
  },
  currentlyLoadingOff() {
    this.currentlyLoading = false;
  },
  resetLoadingPromise() {
    this.loadingPromises = [];
    this.finalData = [];
  },
  emitStartEvent() {
    EventBus.$emit('pageLoadStart');
  },
  emitFinishEvent() {
    EventBus.$emit('pageLoadFinish');
  }
};